import React, { useState, useEffect } from 'react';
import MobileWeeklyBillsPlanner from './MobileWeeklyBillsPlanner';
import WeeklyBillsPlanner from './WeeklyBillsPlanner';

const BillPlannerWrapper = ({ userId, workspaceId }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const checkMobile = () => {
    // Check if device width is less than or equal to 768px
    setIsMobile(window.innerWidth <= 768);
  };

  // Force mobile view if URL contains 'mobile=true'
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const forceMobile = urlParams.get('mobile') === 'true';
    if (forceMobile) {
      setIsMobile(true);
    }
  }, []);

  return isMobile ? (
    <MobileWeeklyBillsPlanner userId={userId} workspaceId={workspaceId} />
  ) : (
    <WeeklyBillsPlanner userId={userId} workspaceId={workspaceId} />
  );
};

export default BillPlannerWrapper; 